import React from "react";

interface MyRadioProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "type"> {
  label: string;
  checked?: boolean;
}

const CustomRadioButton = (props: MyRadioProps) => {
  const { label, checked, className, ...rest } = props;

  return (
    <label className="inline-flex cursor-pointer items-center gap-2">
      <input
        type="radio"
        className="h-4 w-4 accent-yh-blue"
        checked={checked}
        {...rest}
      />
      <span
        className={`text-sm ${
          checked ? "font-medium text-yh-blue" : "text-yh-secondary-text"
        } ${className || ""}`}
      >
        {label}
      </span>
    </label>
  );
};

export default CustomRadioButton;
